/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { correctPosition } from "cms/common/utils/correct-position";
import { isArray } from "utils/empty-exists";
import { getFormReducerState } from "../form-reducer-state";

/**
 * @param {FormReducerDraftState} state
 * @param {FormReducerAction} action
 */
export function FormReducerActions (state, action) {
    const type = action?.type;

    switch (type) {
        case "form/set": {
            /**
             * @type {{form: SchemaForm}}
             */
            const form = action?.form;

            // ensure question options have a position
            for (const question of form.questions) {
                if (isArray(question.options)) {
                    correctPosition(question.options);
                }
            }
            
            // return an object to reset the state
            return {
                ...getFormReducerState(),
                form,
            };
        }
        case "form/update": {
            const form  = action?.form;
            Object.assign(state.form, form);

            break;
        }
        case "form/set-name": {
            state.form.name = action?.name;
            break;
        }

        case "form/dirty": {
            state.isFormDirty = action?.isFormDirty;
            break;
        }

        default:
            return false;
    }

    return state;
}
